// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"377":"20d3c4db","829":"845bb245"}[chunkId] + ".chunk.css";
};